import React, {Component} from 'react';
import { NavLink } from 'react-router-dom';


class AppHeader extends Component {
    static contextTypes = {
        router: () => null, // replace with PropTypes.object if you use them
      }
      resetFilters(){
        document.body.classList.add("show-filter");
        // window.location.reload();
        // localStorage.clear();
        }
    render() {
        
        return(
            <header>
                <div className="left">
                    {this.props.leftButton === 'Favorite' ? 
                    <NavLink to="/favorieten">
                        <img src="/img/hart-icoon-favorieten-pagina_2x.png" alt="img" />
                    </NavLink> : false }

                    {this.props.leftButton === 'Back' ? 
                    <a onClick={this.context.router.history.goBack}>
                        <img src="/img/pijl-links-nav_2x.png" alt="Pijl-Links" />
                    </a> : false }
                </div>
                <div className="middle">
                    <NavLink to={this.props.titleTextLink ? this.props.titleTextLink : '/'}>
                        <h1>{this.props.titleText}</h1>
                    </NavLink>
                </div>
                <div className="right">
                    {this.props.rightButton === 'Reset' ? <a onClick={this.resetFilters}>
                        <p>Resetten</p>
                    </a> : false }

                    {this.props.rightButton === 'Home' ? <NavLink to="/">
                        <img src="/img/home-nav_2x.png" alt="Huisje"/>
                    </NavLink> : false }

                    
                </div>
            </header>
        )
    }
};

export default AppHeader;

